import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types/index';

import { initialState } from './slice';

const selectDomain = (state: RootState) =>
  state.cloudPostureOverview || initialState;

export const selectCloudPostureOverview = createSelector(
  [selectDomain],
  state => state,
);
